import store from '../store/index';
import firebase from 'firebase';
import axios from 'axios';

export default (to, from, next) => {
  firebase.auth().onAuthStateChanged((user) => {
    if (!user) {
      // 
      next('/login');
      store.dispatch('logout');
      return;
    }

    store.dispatch('tryAutoLogin', user);

    store.dispatch('setUserToken', user.xa);
    let queryString = `query checksubscription($email:String!){
                                  checksubscription(email: $email) }`;
    axios
      .post('/graphql', {
        query: queryString,
        variables: {
          email: user.email,
        },
      })
      .then((result) => {
        return result.data.data.checksubscription;
      })
      .then((hasSubscription) => {
        
        if (hasSubscription) {
          return getUserDetails(user.email);
        } 
          store._vm.showError('Your subscription might be expired!');

          store.dispatch('logout');
          return null;
        
      })
      .then((user) => {
        
        if (user) {
          let loggedInUser = store.getters.user;
          loggedInUser.details = user;
          store.dispatch('setUser', loggedInUser);
          next();
        }
      })
      .catch((error) => console.log(error));
  });

  const getUserDetails = (email) => {
    let queryString = `query userDetails2($email:String!){
          userDetails2(email: $email){
          id
          firstname
          lastname
          companyId
          emailAddress
          phoneNumber
          group{
            groupName
          }
          grouprole{
            roles{
              roleCode
            }
          }
        }
      }`;
    return axios
      .post('/graphql', {
        query: queryString,
        variables: {
          email: email,
        },
      })
      .then((result) => {
        if (result.data.data.userDetails2) {
          return result.data.data.userDetails2;
        }
        // let loggedInUser = this.$store.getters.user;
        // loggedInUser.details = result.data.data.userDetails2;
        // this.$store.dispatch("setUser", loggedInUser);
      })
      .catch((error) => {
        this.showError(error.message);
      });
  };
};
